import gsap from 'gsap';
import { HeroTitle } from '../InteractiveMap/HeroTitle';

export class PageTransition {
    constructor(map) {
        this.map = map;
        this.heroTitle = new HeroTitle();
    }

    async animateContentOut(container, next) {
        const isGoingToIndex = next.dataset.barbaNamespace === 'home';

        // Create a timeline for parallel animations
        const timeline = gsap.timeline();

        // Add content fade out
        timeline.to(container, {
            opacity: 0,
            duration: 0.5
        }, 0);  // Start at 0

        // Add hero title animation
        if (isGoingToIndex) {
            this.heroTitle.animateToIndex();
        } else {
            this.heroTitle.animateToDetails();
        }

        // Wait for the timeline to complete
        await timeline.play();
    }

    async animateContentIn(container) {
        const timeline = gsap.timeline();

        timeline.fromTo(container,
            { opacity: 0 },
            { opacity: 1, duration: 0.5 }
        );

        await timeline.play();
    }
}
